<form [formGroup]="additionalInfoForm" *ngIf="connectionChangeConfig$ | async as config">
  <h2>Weitere Informationen</h2>
  <app-upload-documents
    *ngIf="config.ownershipVerificationField !== FieldConfigEnum.HIDDEN"
    [inputFormArray]="additionalInfoForm.controls.ownership"
    [documentTag]="'ownership'"
    [showTag]="false"
    [canUpdate]="true"
    [filterCriteria]="'equal'"
    [numberOfUploads]="10"
    [editUpload]="true"
    [showUploadButton]="true"
    [validFormats]="['.pdf']">
    <p>
      Eigentumsnachweis/Grundbucheintrag{{
        config.ownershipVerificationField === FieldConfigEnum.REQUIRED ? '*' : ''
      }}
      <br />
      Bitte laden Sie uns hier einen Eigentumsnachweis des Anschlussobjektes hoch. (Erlaubte
      Dokumentenformate: ".pdf")
      <br />
    </p>
  </app-upload-documents>
  <mat-error
    *ngIf="
      additionalInfoForm.controls.ownership.touched && additionalInfoForm.controls.ownership.errors?.required
    ">
    Bitte laden Sie mindestens ein Dokument hoch
  </mat-error>
  <br />
  <form-row>
    <mat-checkbox [formControl]="additionalInfoForm.controls.isOwner">
      Ich bin Eigentümer des Anschlussobjektes
    </mat-checkbox>
  </form-row>
  <ng-container *ngIf="isNotOwner$ | async">
    <app-upload-documents
      [inputFormArray]="additionalInfoForm.controls.mandate"
      [documentTag]="'mandate'"
      [showTag]="false"
      [canUpdate]="true"
      [filterCriteria]="'equal'"
      [numberOfUploads]="10"
      [editUpload]="true"
      [showUploadButton]="true"
      [validFormats]="['.pdf']">
      <p>
        Vollmacht*
        <br />
        Bitte laden Sie uns hier die Ihnen erteilte Vollmacht des Eigentümers hoch. (Erlaubte
        Dokumentenformate: ".pdf")
        <br />
      </p>
    </app-upload-documents>
    <mat-error
      *ngIf="
        additionalInfoForm.controls.mandate.touched && additionalInfoForm.controls.mandate.errors?.required
      ">
      Bitte laden Sie mindestens ein Dokument hoch
    </mat-error>
    <br />
  </ng-container>
  <ng-container
    *ngIf="
      config.supplyAppointmentWishDateField !== FieldConfigEnum.HIDDEN &&
      config.connectionChangeRequestType !== ConnectionChangeRequestTypeEnum.TEMPORARY
    ">
    <p>
      Damit Ihr Netzbetreiber die Durchführung besser planen kann, können Sie hier die Woche Ihres
      Wunschdatums angeben (Mo-Fr).
    </p>
    <form-row>
      <mat-form-field fxFlex="50" appearance="outline">
        <mat-label>Kalenderwoche des Wunschdatums</mat-label>
        <mat-select [formControl]="additionalInfoForm.controls.supplyAppointmentWishDate">
          <mat-option
            *ngFor="let option of wishDateOptions$ | async"
            [value]="option ? option.weekStartDate : null">
            {{ option ? option.displayText : 'Keine Präferenz' }}
          </mat-option>
        </mat-select>
        <mat-hint>
          Die Angabe des Wunschdatums ist unverbindlich und garantiert nicht, dass die Durchführung in der
          angegebenen Woche stattfindet.
        </mat-hint>
        <mat-error
          *ngIf="
            additionalInfoForm.controls.supplyAppointmentWishDate.touched &&
            additionalInfoForm.controls.supplyAppointmentWishDate.errors?.required
          ">
          Bitte geben Sie eine Kalenderwoche an
        </mat-error>
      </mat-form-field>
    </form-row>
  </ng-container>
</form>
